const initHeatingElectricityWidget = (widget) => {
  const inputs = widget.querySelectorAll("input");
  Array.from(inputs).forEach((input) => {
    input.addEventListener("change", () => {
      checkHeatingSelection(widget);
    });
  });
};

const setDisabled = (inputs) => {
  inputs.forEach((input) => {
    input.setAttribute("disabled", "");
  });
};

const unsetDisabled = (inputs) => {
  inputs.forEach((input) => {
    input.removeAttribute("disabled");
  });
};

const checkHeatingSelection = (widget) => {
  const messageElement = widget.querySelector("#heatingWidgetError");
  const heatingTypes = widget.querySelectorAll("input[name='heatingType']");
  const heatingType = widget.querySelector("input[name='heatingType']:checked")?.value;
  const seperateMeters = widget.querySelectorAll("input[name='seperateMeter']");
  const seperateMeter = widget.querySelector("input[name='seperateMeter']:checked")?.value;
  const usageWidget = document.querySelector(".js-usage-widget");

  if (seperateMeter && seperateMeter == "no") {
    usageWidget.setAttribute("data-show-dual-usage", "");
    usageWidget.removeAttribute("data-show-single-dual-toggle");
  } else {
    usageWidget.setAttribute("data-show-single-dual-toggle", "");
  }

  heatingType == "heatpump" ? setDisabled(seperateMeters) : unsetDisabled(seperateMeters);
  seperateMeter == "no" ? setDisabled(heatingTypes) : unsetDisabled(heatingTypes);

  if (heatingType == "heatpump" || seperateMeter == "no") {
    messageElement.removeAttribute("hidden");
  } else {
    messageElement.setAttribute("hidden", "");
  }
};

export { initHeatingElectricityWidget };
